























































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, helpers, minLength } from "vuelidate/lib/validators";
import { ILocalePair } from "@/@types/servers/methods-id";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";

import { auth } from "@/config/host.config";
import { CRITICAL_METHODS } from "@/config/critical-methods.config";
import { getPermitions } from "@/services/accessDecoder";
import {
  ITreeModule,
  ITreeServer,
  buildModuleIndex,
  filterTreeByPermissions,
  normalizeMethodsTree,
  relatedMethodIds,
} from "@/services/admin/methods-tree";
import { IRelatedLink, TRelatedScope } from "@/@types/servers/methods-id";

import StandartModal from "@/components/app/standart-modal.vue";

const enalpha = helpers.regex("alpha", /^[a-zA-Z0-9]*$/);

interface IDepView {
  ref: string;
  title: string;
  kinds: string[];
  scope: TRelatedScope;
  ids: string[];
  required: boolean;
  off: boolean;
}

@Component({
  mixins: [validationMixin],
  validations: {
    login: { required, enalpha },
    password: { minLength: minLength(6) },
  },
  components: { StandartModal },
})
class UserCreateModal extends Vue {
  @Prop({ type: Object, default: null }) item!: IUser | null;

  login = "";
  password = "";
  displayName = "";
  role: "admin" | "semiadmin" = "semiadmin";

  loading = true;
  sending = false;
  tree: ITreeServer[] = [];
  moduleIndex = new Map<string, ITreeModule>();

  selectedModules: { [ref: string]: boolean } = {};
  manualAdd: { [id: string]: boolean } = {};
  manualRemove: { [id: string]: boolean } = {};
  depOff: { [ref: string]: boolean } = {};

  openServers: { [key: string]: boolean } = {};
  openModules: { [ref: string]: boolean } = {};
  search = "";
  showAllPerms = false;
  previewLimit = 8;

  /** роль создателя (текущего пользователя) */
  get creatorRole(): string {
    return String(this.$store.getters.getUserRole || "");
  }

  get canGrantAdmin(): boolean {
    return ["root", "admin"].includes(this.creatorRole);
  }

  get isEdit(): boolean {
    return !!(this.item && this.item._id);
  }

  get modalTitle(): string {
    return String(
      this.$t(
        this.isEdit
          ? "Administration.users.create.edit-title"
          : "Administration.users.create.title"
      )
    );
  }

  name(field: ILocalePair): string {
    return this.$getLocale(field);
  }

  /** критические методы недоступны роли semiadmin */
  isIdAllowed(id: string): boolean {
    if (!id) return true;
    if (this.role != "semiadmin") return true;
    return !CRITICAL_METHODS.includes(id);
  }

  isCritical(id: string): boolean {
    return CRITICAL_METHODS.includes(id);
  }

  // ============ дерево / поиск ============

  get visibleTree(): ITreeServer[] {
    const q = this.search.trim().toLowerCase();
    if (!q) return this.tree;
    const match = (...fields: string[]): boolean =>
      fields.join(" ").toLowerCase().includes(q);

    return this.tree
      .map((server) => ({
        ...server,
        modules: server.modules
          .map((mod) => ({
            ...mod,
            methods: mod.methods.filter((m) =>
              match(
                this.name(m.name),
                m.id,
                m.type,
                m.entry_point,
                this.name(mod.name),
                mod.ref
              )
            ),
          }))
          .filter(
            (mod) =>
              mod.methods.length ||
              match(this.name(mod.name), mod.ref, String(server.port))
          ),
      }))
      .filter(
        (server) =>
          server.modules.length ||
          match(this.name(server.name), server.key, String(server.port))
      );
  }

  toggleServer(key: string): void {
    this.$set(this.openServers, key, !this.openServers[key]);
  }

  isServerOpen(key: string): boolean {
    if (this.search.trim()) return true;
    return !!this.openServers[key];
  }

  toggleModuleOpen(ref: string): void {
    this.$set(this.openModules, ref, !this.openModules[ref]);
  }

  isModuleOpen(ref: string): boolean {
    if (this.search.trim()) return true;
    return !!this.openModules[ref];
  }

  // ============ выбор модулей и методов ============

  /** при поиске mod приходит из отфильтрованной копии — берём оригинал */
  baseModule(mod: ITreeModule): ITreeModule {
    return this.moduleIndex.get(mod.ref) || mod;
  }

  allowedMethodIds(mod: ITreeModule): string[] {
    return this.baseModule(mod)
      .methods.filter((m) => !!m.id && this.isIdAllowed(m.id))
      .map((m) => m.id);
  }

  /** фактически выданные id методов самого модуля */
  moduleEffectiveIds(mod: ITreeModule): string[] {
    const allowed = this.allowedMethodIds(mod);
    if (this.selectedModules[mod.ref])
      return allowed.filter((id) => !this.manualRemove[id]);
    return allowed.filter((id) => this.manualAdd[id]);
  }

  moduleSelectedCount(mod: ITreeModule): number {
    const set = this.permissionIdSet;
    return this.allowedMethodIds(mod).filter((id) => set.has(id)).length;
  }

  moduleTotalCount(mod: ITreeModule): number {
    return this.allowedMethodIds(mod).length;
  }

  isModuleChecked(mod: ITreeModule): boolean {
    const total = this.moduleTotalCount(mod);
    return total > 0 && this.moduleSelectedCount(mod) == total;
  }

  isModuleIndeterminate(mod: ITreeModule): boolean {
    const sel = this.moduleSelectedCount(mod);
    return sel > 0 && sel < this.moduleTotalCount(mod);
  }

  toggleModule(mod: ITreeModule): void {
    const ids = this.allowedMethodIds(mod);
    if (this.selectedModules[mod.ref]) {
      this.$delete(this.selectedModules, mod.ref);
    } else {
      this.$set(this.selectedModules, mod.ref, true);
    }
    for (const id of ids) {
      this.$delete(this.manualAdd, id);
      this.$delete(this.manualRemove, id);
    }
  }

  toggleMethod(id: string): void {
    if (this.isMethodLocked(id)) return;
    if (this.isIdSelected(id)) {
      this.$set(this.manualRemove, id, true);
      this.$delete(this.manualAdd, id);
    } else {
      this.$set(this.manualAdd, id, true);
      this.$delete(this.manualRemove, id);
    }
  }

  // ============ зависимости (related) ============

  get activeDeps(): IDepView[] {
    const byRef = new Map<
      string,
      {
        links: IRelatedLink[];
        mod: ITreeModule;
        required: boolean;
        ids: Set<string>;
        rank: number;
      }
    >();

    const scopeRank: { [key in TRelatedScope]: number } = {
      read: 1,
      write: 2,
      all: 3,
    };

    for (const server of this.tree) {
      for (const mod of server.modules) {
        if (!this.selectedModules[mod.ref] || !mod.related.length) continue;
        for (const link of mod.related) {
          const depMod = this.moduleIndex.get(link.ref);
          if (!depMod || this.selectedModules[link.ref]) continue;
          let entry = byRef.get(link.ref);
          if (!entry) {
            entry = {
              links: [],
              mod: depMod,
              required: false,
              ids: new Set<string>(),
              rank: 0,
            };
            byRef.set(link.ref, entry);
          }
          entry.links.push(link);
          if (link.required) entry.required = true;
          entry.rank = Math.max(entry.rank, scopeRank[link.scope]);
          for (const id of relatedMethodIds(depMod, link, (i) =>
            this.isIdAllowed(i)
          ))
            entry.ids.add(id);
        }
      }
    }

    const scopeByRank: TRelatedScope[] = ["read", "read", "write", "all"];
    const out: IDepView[] = [];
    for (const [ref, entry] of byRef) {
      if (!entry.ids.size) continue;
      out.push({
        ref,
        title: this.name(entry.mod.name),
        kinds: [...new Set(entry.links.map((l) => l.kind))],
        scope: scopeByRank[entry.rank],
        ids: [...entry.ids],
        required: entry.required,
        off: !entry.required && !!this.depOff[ref],
      });
    }
    return out;
  }

  toggleDep(ref: string): void {
    const off = !this.depOff[ref];
    this.$set(this.depOff, ref, off);
    if (!off) return;
    const dep = this.activeDeps.find((d) => d.ref == ref);
    if (dep) for (const id of dep.ids) this.$delete(this.manualAdd, id);
  }

  // ============ итоговый набор ============

  get permissionIdSet(): Set<string> {
    const out = new Set<string>();
    for (const server of this.tree)
      for (const mod of server.modules)
        for (const id of this.moduleEffectiveIds(mod)) out.add(id);
    for (const dep of this.activeDeps) {
      if (dep.off) continue;
      for (const id of dep.ids) out.add(id);
    }
    return out;
  }

  get permissionIds(): string[] {
    return [...this.permissionIdSet];
  }

  get autoIdSet(): Set<string> {
    const out = new Set<string>();
    for (const dep of this.activeDeps) {
      if (dep.off) continue;
      for (const id of dep.ids) out.add(id);
    }
    return out;
  }

  get requiredIdSet(): Set<string> {
    const out = new Set<string>();
    for (const dep of this.activeDeps) {
      if (!dep.required) continue;
      for (const id of dep.ids) out.add(id);
    }
    return out;
  }

  isAutoId(id: string): boolean {
    return this.autoIdSet.has(id);
  }

  isMethodLocked(id: string): boolean {
    return (
      this.requiredIdSet.has(id) ||
      this.autoIdSet.has(id) ||
      !this.isIdAllowed(id)
    );
  }

  isIdSelected(id: string): boolean {
    return this.permissionIdSet.has(id);
  }

  get summaryPreview(): Array<{
    id: string;
    type: string;
    title: string;
    auto: boolean;
  }> {
    const limit = this.showAllPerms
      ? this.permissionIds.length
      : this.previewLimit;
    return this.permissionIds.slice(0, limit).map((id) => {
      const info = this.idInfo.get(id);
      return {
        id,
        type: info ? info.type : "",
        title: info ? info.title : id,
        auto: this.isAutoId(id),
      };
    });
  }

  /** id → название/тип для превью */
  get idInfo(): Map<string, { type: string; title: string }> {
    const map = new Map<string, { type: string; title: string }>();
    for (const server of this.tree)
      for (const mod of server.modules)
        for (const m of mod.methods)
          if (!map.has(m.id))
            map.set(m.id, { type: m.type, title: this.name(m.name) });
    return map;
  }

  // ============ серверные счётчики ============

  selectedInServer(server: ITreeServer): number {
    return server.modules.reduce(
      (sum, mod) => sum + this.moduleSelectedCount(mod),
      0
    );
  }

  totalInServer(server: ITreeServer): number {
    return server.modules.reduce(
      (sum, mod) => sum + this.moduleTotalCount(mod),
      0
    );
  }

  isServerFull(server: ITreeServer): boolean {
    const total = this.totalInServer(server);
    return total > 0 && this.selectedInServer(server) == total;
  }

  // ============ роль ============

  setRole(role: "admin" | "semiadmin"): void {
    if (role == "admin" && !this.canGrantAdmin) return;
    this.role = role;
  }

  // ============ редактирование ============

  applyItem(): void {
    if (!this.item) return;
    this.login = this.item.login || "";
    this.displayName = this.item.room_number || "";
    this.role = this.item.rules == "admin" ? "admin" : "semiadmin";
    this.applyPermissions();
  }

  /** отмечает в дереве права, уже выданные пользователю */
  applyPermissions(): void {
    const perms = new Set<string>(this.item?.permissions || []);
    if (!perms.size || !this.tree.length) return;
    for (const server of this.tree)
      for (const mod of server.modules) {
        const allowed = this.allowedMethodIds(mod);
        const selected = allowed.filter((id) => perms.has(id));
        if (allowed.length && selected.length == allowed.length)
          this.$set(this.selectedModules, mod.ref, true);
        else for (const id of selected) this.$set(this.manualAdd, id, true);
      }
  }

  // ============ submit ============

  get canSubmit(): boolean {
    return (
      !this.$v.$invalid &&
      (this.isEdit || !!this.password) &&
      !!this.permissionIds.length &&
      !this.sending
    );
  }

  async onSubmit(event: Event): Promise<void> {
    event.preventDefault();
    this.$v.$touch();
    if (!this.canSubmit) return;

    this.sending = true;
    const payload: Partial<IUser> = {
      login: this.login,
      rules: this.role,
      room_number: this.displayName,
      permissions: this.permissionIds,
    };
    if (this.password) payload.password = this.password;

    try {
      const res = this.isEdit
        ? await this.$axios.put(`${auth.user}/${this.item?._id}`, payload)
        : await this.$axios.post(auth.registration, payload);
      if (res.status == 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit(this.isEdit ? "changed" : "created", res.data);
        this.onReset();
        this.$bvModal.hide("user-create-modal");
      }
    } catch (error) {
      const status = (error as { response?: { status?: number } })?.response
        ?.status;
      const text =
        status == 422
          ? String(this.$i18n.t("Administration.users.create.exists"))
          : String(this.$i18n.t("alerts.emptyUpdate"));
      this.$notify({ group: "global", text, type: "warn" });
    } finally {
      this.sending = false;
    }
  }

  onReset(): void {
    this.login = "";
    this.password = "";
    this.displayName = "";
    this.role = "semiadmin";
    this.selectedModules = {};
    this.manualAdd = {};
    this.manualRemove = {};
    this.depOff = {};
    this.search = "";
    this.showAllPerms = false;
    this.$v.$reset();
  }

  async loadTree(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.$axios.get(auth.getAPI);
      if (res.status == 200) {
        const permitions = this.$isRoot() ? null : getPermitions();
        let tree = filterTreeByPermissions(
          normalizeMethodsTree(res.data),
          permitions
        );
        // show: false — сервис скрыт от администратора (виден только root)
        if (!this.$isRoot()) tree = tree.filter((s) => s.show !== false);
        this.tree = tree;
        this.moduleIndex = buildModuleIndex(this.tree);
        if (this.tree.length)
          this.$set(this.openServers, this.tree[0].key, true);
        this.applyPermissions();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  mounted(): void {
    this.loadTree();
  }

  destroyed(): void {
    this.tree = [];
    this.moduleIndex = new Map();
  }
}

export default UserCreateModal;
